import React from 'react';
import styled from 'styled-components';
import Accordion from './accordion';
const TextBox = styled.div `
  font-size: 16px;
  white-space: pre-wrap;
`;
const AccordionItem = ({ itemIndex, openAccordions, title, content, }) => {
    const formattedContent = Array.isArray(content)
        ? content.map((item, index, array) => React.createElement("div", { key: index },
            React.createElement("p", null, item),
            Number(index) === array.length - 1 ? null : React.createElement("br", null)))
        : content;
    return (React.createElement(Accordion, { show: openAccordions.includes(itemIndex), title: title, isBlueHeading: true },
        React.createElement(TextBox, { className: 'pad-bottom-md pad-right-lg' }, formattedContent)));
};
export default AccordionItem;
